import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const response = await api.get('/student/reports');
      setReports(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadReport = async (reportId) => {
    try {
      const response = await api.get(`/student/reports/${reportId}/download`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bulletin_${reportId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-[#2C3E50] mb-6">Mes bulletins</h1>

      {loading ? (
        <div className="text-center py-10">Chargement...</div>
      ) : (
        <div className="space-y-4">
          {reports.map((report) => (
            <div key={report.id} className="card flex justify-between items-center hover:shadow-lg transition">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center">
                  <span className="text-2xl">📄</span>
                </div>
                <div>
                  <h3 className="font-semibold text-[#2C3E50]">{report.title}</h3>
                  <p className="text-sm text-gray-500">{report.period}</p>
                  <p className="text-sm text-gray-500">Moyenne : {report.average} - Rang : {report.rank}</p>
                </div>
              </div>
              <div className="flex space-x-3">
                <span className={`px-3 py-1 rounded-full text-sm ${
                  report.status === 'published' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                }`}>
                  {report.status === 'published' ? 'Publié' : 'En attente'}
                </span>
                {report.status === 'published' && (
                  <button
                    onClick={() => downloadReport(report.id)}
                    className="text-[#E67E22] hover:text-[#D35400] transition"
                  >
                    ⬇️ PDF
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reports;